import { render, staticRenderFns } from "./aiDistinguish.vue?vue&type=template&id=6ec46a0c&scoped=true"
import script from "./aiDistinguish.vue?vue&type=script&lang=js"
export * from "./aiDistinguish.vue?vue&type=script&lang=js"
import style0 from "./aiDistinguish.vue?vue&type=style&index=0&id=6ec46a0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec46a0c",
  null
  
)

export default component.exports